// extracted by mini-css-extract-plugin
export var galerieContainer = "galerie-images-module--galerie-container--a73ae";
export var galerieImage = "galerie-images-module--galerie-image--f9b98";
export var galerieItemContainer = "galerie-images-module--galerie-item-container--4b6a1";
export var galerieItemDescription = "galerie-images-module--galerie-item-description--36249";
export var galerieItemHeader = "galerie-images-module--galerie-item-header--1361f";
export var galerieItemLink = "galerie-images-module--galerie-item-link--d4c97";
export var galerieItemTitle = "galerie-images-module--galerie-item-title--6a963";
export var masonryGrid = "galerie-images-module--masonry-grid--31ecc";
export var masonryGridColumn = "galerie-images-module--masonry-grid-column--70a47";